import React, { useRef, useState,useEffect } from 'react';
import {
  GoogleMap,
  LoadScript,
  Marker,
} from '@react-google-maps/api';
import MapPin from '../../svg/MapPinFull.svg';
import { useShopConfig } from '@jetshop/core/hooks/useShopConfig';
import { mapStyle } from '../StoreLocator/StoreMap';
import { ReactComponent as MapMarker } from '../../svg/MapPinFull.svg';
import t from '@jetshop/intl';

export const StoreDetail = (props) => {
  const { store } = props;
  const ref = useRef()
  const { googleMapsApiKey } = useShopConfig();
  const [mapLoaded,setMapLoaded] = useState(false)
    var other = store.other
      ?.replace(/<[^>]*>/g, '')
      ?.replace(/\r?\n|\r/g, '-')
      ?.split('-');

    var lat = parseFloat(other[0]);
    var lng = parseFloat(other[1]);


    useEffect(() => {
      if (store && mapLoaded) {
            var other = store.other
              ?.replace(/<[^>]*>/g, '')
              ?.replace(/\r?\n|\r/g, '-')
              ?.split('-');

            var lat = parseFloat(other[0]);
            var lng = parseFloat(other[1]);
        // User has shared its location and the closest store has been calculated
        const bounds = new window.google.maps.LatLngBounds();
  
        bounds.extend(new window.google.maps.LatLng(lat, lng));
        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
          const extendPoint1 = new window.google.maps.LatLng(
            bounds.getNorthEast().lat() + 0.01,
            bounds.getNorthEast().lng() + 0.01
          );
          const extendPoint2 = new window.google.maps.LatLng(
            bounds.getNorthEast().lat() - 0.01,
            bounds.getNorthEast().lng() - 0.01
          );
          bounds.extend(extendPoint1);
          bounds.extend(extendPoint2);
        }
        ref.current.fitBounds(bounds);
      }
    }, [store, mapLoaded]);

    return (
      <>
        <LoadScript
          loadingElement={<div></div>}
          preventGoogleFontsLoading={true}
          googleMapsApiKey={googleMapsApiKey}
        >
          <GoogleMap
            maxZoom={10}
            mapContainerClassName="map-container"
            defaultCenter={{ lat: 59.247948, lng: 14.755806 }}
            onLoad={map => {
              ref.current = map;
              setMapLoaded(true);
            }}
            options={{ styles: mapStyle }}
          >
            {mapLoaded && (
              <Marker
                icon={{
                  url: MapPin,
                  fillColor: '#235838',
                  fillOpacity: 1,
                  strokeColor: 'transparent',
                  anchor: new window.google.maps.Point(12, 32),
                  scaledSize: new window.google.maps.Size(25, 32)
                }}
                position={{
                  lat: lat,
                  lng: lng
                }}
              />
            )}
          </GoogleMap>
        </LoadScript>
        <div>
          <h1>{store?.name}</h1>
          <a
            className="directions-link"
            target="_blank"
            href={
              'https://www.google.com/maps/search/?api=1&query=Hööks+' +
              store.address1
            }
            rel="noreferrer"
          >
            <MapMarker />
            {t('Directions')}
          </a>
          <div className="address">
            <span
              dangerouslySetInnerHTML={{
                __html: store.address1
              }}
            />
          </div>
          <div className="contact">
            <span
              dangerouslySetInnerHTML={{
                __html: store.contact
              }}
            />
          </div>
          <div className="opening-hours">
            <span
              dangerouslySetInnerHTML={{
                __html: store.openHours
              }}
            />
          </div>
          <div className="odd-opening-hours">
            <span
              dangerouslySetInnerHTML={{
                __html: store.description
              }}
            />
          </div>
        </div>
      </>
    );
}
